// extracted by mini-css-extract-plugin
export default {"text":"DisplayCard_text__WW57e","header":"DisplayCard_header__BySup"};